<template>
  <CustomModal
    :isModalOpen="isOpen"
    @toggleModal="$emit('reset')"
    @onClickAway="$emit('reset')"
    :overlay="'dark'"
    :with-header="true"
    :with-footer="true"
    custom-classes="tw:h-screen tw:md:h-auto tw:w-[100vw] tw:md:max-w-[588px] tw:md:w-[588px] tw:md:rounded-md tw:rounded-none"
  >
    <template #modalHeader>
      <h3 class="tw:font-bold tw:text-xl tw:text-gray-700">{{ $t('subscription_reactivate_modal_header') }}</h3>
    </template>
    <div
      @click.stop
      class="tw:flex tw:w-full tw:items-center tw:justify-center tw:min-h-20"
      v-if="isLoading"
    >
      <SmallDotLoader />
    </div>
    <div class="tw:flex tw:flex-col tw:w-full" v-else>
      <StudioPlusReactivationCancelled
        :defaultPaymentMethod="defaultPaymentMethod"
        :nextPaymentDate="nextPaymentDate"
        :isActivationDateNotToday="isActivationDateNotToday"
        :price="price"
        :loading="isPriceLoading || isPriceFetching"
        :type="type"
        :cardExpiresSoon="cardExpiresSoon"
        :cardExpirationDate="cardExpirationDate"
        @applyVoucherCode="$emit('applyVoucherCode', $event)"
      />
    </div>
    <template #modalFooter>
      <div class="tw:flex tw:justify-end tw:w-full">
        <GhostButton @click="$emit('cancel')">{{ $t('cancel') }}</GhostButton>
        <MainButton
          @click="$emit('reactivate')"
          class="tw:ml-6"
          :disabled="
            !defaultPaymentMethod || defaultPaymentMethod?.expired || defaultPaymentMethod?.type === 'WIRE_TRANSFER'
          "
        >
          <span v-show="!isUpdating">{{ $t('subscription_reactivate_modal_header') }}</span>
          <span v-show="isUpdating" class="tw:px-4"><SmallDotLoader color="#fff" /></span>
        </MainButton>
      </div>
    </template>
  </CustomModal>
</template>
<script setup>
import CustomModal from '@/components/base/CustomModal.vue'
import StudioPlusReactivationCancelled from '@/components/billing/premiumProducts/reactivation/StudioPlusReactivationCancelled.vue'
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'

defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  defaultPaymentMethod: {
    type: Object,
    default: null,
  },
  nextPaymentDate: {
    type: String,
    default: null,
  },
  isActivationDateNotToday: {
    type: Boolean,
    default: false,
  },
  price: {
    type: Object,
    default: null,
  },
  isPriceLoading: {
    type: Boolean,
    default: false,
  },
  isPriceFetching: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'YEARLY',
  },
  cardExpiresSoon: {
    type: Boolean,
    default: false,
  },
  cardExpirationDate: {
    type: Date,
    default: null,
  },
  isUpdating: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['reactivate', 'cancel', 'reset', 'applyVoucherCode'])
</script>
